class PlannersInterviewController {
    constructor() {

        this.setContentPadding();
        this.setPickupSPSlider();
        this.setDetailSlider();
        this.setStaffDetail();
    }

    setContentPadding() {
        if ($('.planners_interview-detail__content').length < 1) {
            return;
        }
        $('.planners_interview-detail__content p').each(function () {
            let $this = $(this);
            if ($this.find('img').length > 0) {
                $this.addClass('has-img');
            }
        });
    }

    setPickupSPSlider() {
        if ($('.planners_interview-detail__pickup-item').length < 1) {
            return;
        }
        let $items = $('.planners_interview-detail__pickup-items .swiper-slide').clone(false.false);
        
        $('#js-planners_interview-detail__pickup-slider .swiper-wrapper').append($items);

        let options = {
            loop: true,
            loopAdditionalSlides: 3,
            // loopedSlides: 5,
            // freeMode: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            loopFillGroupWithBlank: false,
            // updateOnWindowResize: false,
            // width: (window.UA.isSP)? 210: 420,
            centeredSlides: false,
            // centerInsufficientSlides: true,
            // width: (this.UA.isSP)? 190: 190,
            spaceBetween: (window.UA.isSP) ? 28 : 40,
            slidesPerView: 'auto',
            // slidesPerGroup: 1,
            navigation: {
                nextEl: '#js-planners_interview-detail__pickup-slider-next',
                prevEl: '#js-planners_interview-detail__pickup-slider-prev',
            },
            // scrollbar: {
            //     el: '#js-home-voice__slider-bar',
            //     // hide: true,
            //     draggable: false,
            // },
            touchAngle: 20,
            speed: 800,
            // pagination: {
            // el: '#js-mainvisual__slider-pagination',
            // clickable: true,
            // renderBullet: function (index, className) {
            //     return `<div class="mainvisual__slider-pagination-bullet"><svg width="44" height="44"><circle cx="22" cy="22" r="21" /></svg><span>0${(index + 1)}</span></div>`;
            // },
            // bulletClass: 'mainvisual__slider-pagination-bullet',
            // bulletActiveClass: 'is-active'
            // },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            on: {
                // onSlideChangeEnd : (s) => {s.fixLoop();}
            },
        };

        if ($('.planners_interview-detail__pickup-item').length < 2) {

            options.centeredSlides = true;
        }
        let pickupSlider = new Swiper('#js-planners_interview-detail__pickup-slider', options);
        if (window.UA.isSP) {
            pickupSlider.off('resize');
            let height = [];
            $('#js-planners_interview-detail__pickup-slider .swiper-slide').each(function(){
                let $this = $(this);
                height.push($this.height());
            });
            $('#js-planners_interview-detail__pickup-slider .swiper-slide').css({
                height: `${Math.max.apply(null, height)}px`
            });
            // console.log(Math.max.apply(null, height));
        }
    }

    setDetailSlider() {
        if ($('#js-planners_interview-detail__slider').length < 1) {
            return;
        }
        let _this = this;
        let beforeStatus = {};
        let thumbOptions = {
            spaceBetween: window.UA.isSP ? 4 : 4,
            slidesPerView: window.UA.isSP ? 'auto' : 'auto',
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: false,
            preventClicks: false,
            preventClicksPropagation: false,
            preventInteractionOnTransition: false,
            // passiveListeners: false,
            allowTouchMove: window.UA.isSP ? true : false,
            // on: {
            //     click: function (swiper) {
            //         console.log(swiper.clickedIndex);
            //     }
            // }
        };
        this.thumbSlider = new Swiper(
            '#js-planners_interview-detail__thumb-slider',
            thumbOptions
        );
        //
        let options = {
            preloadImages: false,
            lazy: true,
            // loop: true,
            // loopAdditionalSlides: 1,
            // freeMode: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            // updateOnWindowResize: false,
            // width: (window.UA.isSP)? 210: 420,
            // centeredSlides: true,
            // centerInsufficientSlides: true,
            // width: (this.UA.isSP)? 190: 190,
            // spaceBetween:  (window.UA.isSP)? 25: 40,
            slidesPerView: 1,
            preventClicks: false,
            preventClicksPropagation: false,
            preventInteractionOnTransition: true,
            touchAngle: 20,
            // slidesPerGroup: 1,
            // slideToClickedSlide: true,
            // navigation: {
            //     nextEl: '#js-voice-detail__slider-next',
            //     prevEl: '#js-voice-detail__slider-prev',
            // },
            scrollbar: {
                el: '#js-planners_interview-detail__slider-bar',
                // hide: true,
                draggable: true,
            },
            speed: 450,
            // pagination: {
            // el: '#js-mainvisual__slider-pagination',
            // clickable: true,
            // renderBullet: function (index, className) {
            //     return `<div class="mainvisual__slider-pagination-bullet"><svg width="44" height="44"><circle cx="22" cy="22" r="21" /></svg><span>0${(index + 1)}</span></div>`;
            // },
            // bulletClass: 'mainvisual__slider-pagination-bullet',
            // bulletActiveClass: 'is-active'
            // },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            on: {
                
                beforeTransitionStart: () => {
                    if (this.mainSlider) {
                        if (
                            beforeStatus.index ===
                            this.mainSlider.activeIndex &&
                            beforeStatus.isEnd === this.mainSlider.isEnd
                        ) {
                            this.mainSlider.slideTo(0);
                        }
                        beforeStatus.index = this.mainSlider.activeIndex;
                        beforeStatus.isEnd = this.mainSlider.isEnd;
                        // console.log(beforeStatus);
                    }
                },
            },
            thumbs: {
                swiper: this.thumbSlider,
            },
        };
        this.mainSlider = new Swiper('#js-planners_interview-detail__slider', options);
        if (window.UA.isSP) {
            this.mainSlider.off('resize');
        }
        // $('#js-voice-detail__slider-next').on('click', () => {
        //     // console.log(this.mainSlider.isEnd);
        //     if (this.mainSlider.isEnd === true) {
        //         this.mainSlider.slideTo(0);
        //     }
        // });
    }

    setStaffDetail() {
        let $thumb = $('.planners_interview-detail__info-staff-item');
        if ($thumb.length < 1) {
            return;
        }
        let $spwraper = $('.planners_interview-detail__staff-detail-sp');
        $thumb.each(function () {
            let $this = $(this);
            let detail = $this.data('detail');
            $this.on('click', function (e) {
                e.preventDefault();

                $('.planners_interview-detail__staff-detail-item').slideUp(32);
                $(`.${detail}`).stop().slideDown();
            });
            $(`.${detail}`).find('.planners_interview-detail__staff-detail-item-close').on('click', function (e) {
                e.preventDefault();
                $('.planners_interview-detail__staff-detail-item').fadeOut().slideUp(100);
            });;
        });
        let $spItem = $('.planners_interview-detail__staff-detail-item').clone(true, true);
        $spwraper.append($spItem);
    }
}

export default PlannersInterviewController;